"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type DeleteSituationsRequest } from "@/generated/fastapi";
import { deleteSituations } from "../api/deleteSituations";
import { situationsKeys } from "../queries/keys";

export default function useDeleteSituationsMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: DeleteSituationsRequest) =>
      deleteSituations(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: situationsKeys.all });
    },
  });
}
